import fetcher from '../utils/api';

const searchService = {
  search: async (query) => fetcher(`search/?q=${encodeURIComponent(query)}`, 'GET', true),
  knowledgePages: async (query) => fetcher(`search/pages/?q=${encodeURIComponent(query)}`, 'GET', true),
  elasticSearch: async (query, filters) => {
    const appTagFilters = filters?.appTag ? `${filters?.appTag?.map((tag) => `"${tag}"`).join(',')}` : '';
    const authorFilters = filters?.author ? `${filters?.author?.map((author) => `"${author}"`).join(',')}` : '';
    const orgFilters = filters?.workspace ? `${filters?.workspace?.map((workspace) => `"${workspace}"`).join(',')}` : '';
    const docTypeFilters = filters?.docType && filters?.docType !== 'all' ? `&kind=${filters?.docType}` : '';
    const writableFilter = filters?.writable && filters?.writable === 'true' ? `&writable=true` : '';
    const resultsTypeFilters = filters?.resultsType && filters?.resultsType !== 'all' ? `&results_type=${filters?.resultsType}` : '';

    return fetcher(
      `c5f3bf32c4a909b4959e61009ddc299ad952efa5c6a406bddb/search?q=${encodeURIComponent(query)}&app_tags=[${encodeURIComponent(
        appTagFilters
      )}]&authors=[${encodeURIComponent(authorFilters)}]&orgs=[${encodeURIComponent(
        orgFilters
      )}]${docTypeFilters}${resultsTypeFilters}${writableFilter}`,
      'GET',
      true
    );
  }
};

export default searchService;
